var map = {
	"./answerIcon.png": "./src/assets/images/newLogin/answerIcon.png",
	"./customerService.png": "./src/assets/images/newLogin/customerService.png",
	"./customerServiceIcon.png": "./src/assets/images/newLogin/customerServiceIcon.png",
	"./editIcon.png": "./src/assets/images/newLogin/editIcon.png",
	"./emailIcon.png": "./src/assets/images/newLogin/emailIcon.png",
	"./hasSelected.png": "./src/assets/images/newLogin/hasSelected.png",
	"./jumpToTheNextStepIcon.png": "./src/assets/images/newLogin/jumpToTheNextStepIcon.png",
	"./logOutIcon.png": "./src/assets/images/newLogin/logOutIcon.png",
	"./loginAndRegisterBg.png": "./src/assets/images/newLogin/loginAndRegisterBg.png",
	"./newFunction.png": "./src/assets/images/newLogin/newFunction.png",
	"./phoneIcon.png": "./src/assets/images/newLogin/phoneIcon.png",
	"./questionIcon.png": "./src/assets/images/newLogin/questionIcon.png",
	"./questionIconLarge.png": "./src/assets/images/newLogin/questionIconLarge.png",
	"./questionIconSelectedStyle.png": "./src/assets/images/newLogin/questionIconSelectedStyle.png",
	"./secureEmail.png": "./src/assets/images/newLogin/secureEmail.png",
	"./securePhone.png": "./src/assets/images/newLogin/securePhone.png",
	"./secureQuestionAnswers.png": "./src/assets/images/newLogin/secureQuestionAnswers.png",
	"./securityIcon.png": "./src/assets/images/newLogin/securityIcon.png",
	"./sendIcon.png": "./src/assets/images/newLogin/sendIcon.png",
	"./teamIcon.png": "./src/assets/images/newLogin/teamIcon.png",
	"./unSelected.png": "./src/assets/images/newLogin/unSelected.png",
	"./walletIcon.png": "./src/assets/images/newLogin/walletIcon.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/newLogin sync recursive ^\\.\\/.*\\.png$";